var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmartScoreBoard = function SvgSmartScoreBoard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.312 8.175c.266-.117.55-.175.835-.175v25.698l-15.259 6.51A2.074 2.074 0 0 1 10 38.3V17.146c0-.823.486-1.568 1.239-1.899l16.073-7.072Zm3.745 39.97c-1.371.603-2.91-.401-2.91-1.899V8c.285 0 .57.058.836.175l16.073 7.072a2.074 2.074 0 0 1 1.238 1.899v22.94c0 .823-.486 1.568-1.238 1.9l-14 6.159ZM44.429 16.67l-14.726-6.48v36.055c0 .375.384.626.727.475l14-6.16a.519.519 0 0 0 .309-.474V17.146a.519.519 0 0 0-.31-.475Z",
    fill: "currentColor"
  })));
};
export default SvgSmartScoreBoard;